<template>
<table class="table" v-if="students.length">
  <tbody>
    <tr v-for="(student, i) in students" :key="student.id">
      <td class="howmake__stud">
        <div class="student-name">
          <router-link :to="'/student/' + student.id">
            {{ student.name }}
          </router-link>
          <!-- <span class="feedback">            
            <a href="#" v-if="!student.student_reports.length" @click.prevent="$emit('add-feedback', student)" class="os_t__item" uk-tooltip="Оставить обратную связь"></a>
            <a href="#" v-else @click.prevent="$emit('add-feedback', student)" class="os_t__item os_t__item--active" uk-tooltip="Обратная связь оставлена"></a>
          </span> -->
        </div>       

        <small>Коинов за период: {{ student.coins.length }}</small>
        <div class="student-menu">
          <button 
            type="button" 
            class="header-menu__btn header-menu__btn--remove" 
            @click="$emit('remove-student', { student, index: i})"
          >
            <i class="fas fa-trash-alt"></i>
            Удалить
          </button>
        </div>
      </td>
      <td class="howmake__hw" v-for="(item, key) in items" :key="item.id">
        <span class="howmake__date">{{ key }}</span>
        <div class="howmake__trainerblock">
          <div class="howmake__trainers">
            <div v-for="hw in item" :key="hw.id">
              <span v-if="(hw.student_id === student.id) && hw.homework && hw.homework.trainer" :class="hw.is_done ? 'done' : 'false'" :uk-tooltip="hw.homework.trainer.title"></span>
            </div>
          </div>
          <!-- <div class="howmake__result">{{ returnCompletedHW(item, student.id) === 0 ? 'Не выполнено' : `Результат ${returnCompletedHW(item, student.id)}%` }}</div> -->
        </div>
      </td>
    </tr>
  </tbody>
</table>
</template>

<script>
import { hw_completed_mix } from '../../stats/hw_completed_mixin'
import Feedback from './Feedback'
export default {
  name: "students-list",
  inject: ['http'],
  data() {
    return {
      items: ''
    }
  },
  components: {
    Feedback
  },
  mixins: [
    hw_completed_mix
  ],
  props: {
    class_id: '',
    students: ''
  },
  methods: {
    // checkTodayFeedback(data) {
    //   let todayFeedback = data.find(item => new Date(item.date).toDateString() === new Date().toDateString())
    //   return todayFeedback ? true : false
    // },
    init() {
      let data = {
        'class_id': this.class_id
      }
      this.http.post('onGetClassHomeworks', data).then(res => {
        this.items = res.data
        console.log(this.items)
      })
    }
  },
  mounted() {
    this.init();
    
  }
}
</script>

<style lang="scss" scoped>
.os_t__item {
  margin: 0;
  margin-right: 5px;
}

.student-menu {
  margin-top: 20px;
  font-size: 13px;
}

.feedback {
  margin-left: 10px;
}

.student-name {
  display: flex;
  justify-content: space-between;
}

.header-menu__btn {
  font-size: 12px;
}
</style>
